/**
 * Definitions behind every number in the report (docs/kakao-report-card-spec.md §4).
 * Exported from ./index so the report copy and UI footnotes quote the same values.
 */

/** A silence of at least this many minutes starts a new conversation (대화). */
export const CONVERSATION_GAP_MINUTES = 240;
/** 칼답: a reply delay of at most this many minutes. KakaoTalk timestamps are per minute. */
export const QUICK_REPLY_MINUTES = 1;
/** Reply-speed numbers stay null for people with fewer replies than this. */
export const MIN_REPLIES_FOR_SPEED = 10;
/** 단답: a text message with at most this many non-whitespace characters. */
export const SHORT_REPLY_MAX_CHARS = 2;
/** 새벽: wall-clock hours that count as late night (00:00-04:59). */
export const LATE_NIGHT_HOURS: readonly number[] = Object.freeze([0, 1, 2, 3, 4]);
export const TOP_EMOJIS = 5;
export const TOP_WORDS = 10;
export const TOP_CATCHPHRASES = 5;
/** Snippets and excerpts keep at most this many code points, then "…". */
export const SNIPPET_MAX_CHARS = 120;

/** How many messages ChatStats.firstMessages / lastMessages keep. */
export const FIRST_LAST_MESSAGES = 5;
/** 말버릇: the person uses the word at least this many times... */
export const CATCHPHRASE_MIN_COUNT = 5;
/** ...and at least this many times as often as everyone else (smoothed ratio). */
export const CATCHPHRASE_MIN_RATIO = 1.5;
/** 좋은 아침: greetings count when sent before this wall-clock hour (00:00-11:59). */
export const MORNING_END_HOUR = 12;
